import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './MisHistory.css';
import axios from 'axios';
import { toast } from 'react-toastify';

const MisHistory = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false); 
  const [filter, setFilter] = useState('All');
  const [selectedTxn, setSelectedTxn] = useState(null);
  
  const { row } = location.state || {};



  const fetchTransactionData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://payyug.in/api/all-saving-account/transaction-all?accountId=${row.id}&accountType=${row.accountType}`
      );
      setData(response?.data?.statement || []);
    } catch (error) {
      console.error("Error fetching report:", error);
      toast.error("Failed to load transactions");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (row) fetchTransactionData();
  }, [row]);

  // Updated Filter Logic
  const filteredData = data.filter((item) => {
    const remark = item.remarks || "";
    const matchesSearch = remark.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter = filter === 'All' || (item.status && item.status.toLowerCase() === filter.toLowerCase());
    return matchesSearch && matchesFilter;
  });

    // Redirect if no data
  if (!row) {
    return (
      <div className="mis-history-error-container">
        <div className="error-card">
          <h2>No Data Found</h2>
          <p>Please select an account from the dashboard.</p>
          <button onClick={() => navigate(-1)} className="mis-history-header-back-btn">Go Back</button>
        </div>
      </div>
    );
  }
  return (
    <div className="mis-history-container">
      {/* Header */}
      <div className="mis-history-header-section">
        <button className="mis-history-header-back-btn" onClick={() => navigate(-1)}>← Back</button>
        <h1>Account History</h1>
      </div>

      {/* Account Summary */}
      <div className="mis-history-account-summary-card">
        <h3>Account Details</h3>
        <div className="mis-history-account-summary-grid">
          <div><label>Name</label> <span>{row?.customer?.fullName || 'N/A'}</span></div>
          <div><label>Account No</label> <span>{row.accountNumber || 'N/A'}</span></div>
          <div><label>Account Type</label> <span>{row.accountType || 'N/A'}</span></div>
          <div><label>Status</label> <span className="status-badge status-completed">{row.status || 'Active'}</span></div>
        </div>
      </div>

      {/* Controls */}
      <div className="mis-history-filter-bar">
        <input 
          type="text" 
          placeholder="Search remarks..." 
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <select onChange={(e) => setFilter(e.target.value)}>
          <option value="All">All Status</option>
          <option value="Completed">Completed</option>
          <option value="Pending">Pending</option>
          <option value="Failed">Failed</option>
        </select>
      </div>

      {/* Table */}
      <div className="mis-history-table-wrapper">
        <table className="mis-history-table">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Txn Type</th>
              <th>Amount</th>
              <th>Payment Mode</th>
              <th>Refrence No</th>
              <th>Balance After Txn</th>
              <th>Txn Date</th>
              <th>Remark</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
                <tr><td colSpan="9" style={{textAlign:'center'}}>Loading...</td></tr>
            ) : filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <tr key={item.id || index} onClick={() => setSelectedTxn(item)} style={{cursor: 'pointer'}}>
                   <td>{index + 1}</td>
                   <td>{item.txnType || "N/A"}</td>
                   <td>{item.amount ? `₹${item.amount}` : "N/A"}</td>
                   <td>{item.paymentMode || "N/A"}</td>
                   <td>{item.referenceNo || "N/A"}</td>
                   <td>{item.balanceAfterTxn ? `₹${item.balanceAfterTxn}` : "N/A"}</td>
                   <td>{item.txnDate ? new Date(item.txnDate).toLocaleDateString("en-GB") : "N/A"}</td>
                   <td>{item.remarks || "N/A"}</td>
                   <td>
                     <span className={`status-pill status-${(item.status || "").toLowerCase()}`}>
                       {item.status || "N/A"}
                     </span>
                   </td>
                </tr>
              ))
            ) : (
              <tr><td colSpan="9" className="empty-msg">No transactions found</td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Detail Modal */}
      {selectedTxn && (
        <div className="mis-history-modal-overlay" onClick={() => setSelectedTxn(null)}>
          <div className="mis-history-modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Transaction Details</h3>
            <div className="mis-history-modal-content-detail-row"><span>ID:</span> <strong>{selectedTxn.id}</strong></div>
            <div className="mis-history-modal-content-detail-row"><span>Remarks:</span> <strong>{selectedTxn.remarks}</strong></div>
            <div className="mis-history-modal-content-detail-row"><span>Amount:</span> <strong>₹{selectedTxn.amount}</strong></div>
            <div className="mis-history-modal-content-detail-row"><span>Type:</span> <strong>{selectedTxn.txnType}</strong></div>
            <button className="mis-history-modal-content-close-btn" onClick={() => setSelectedTxn(null)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default MisHistory;